<template>
  <div>
    <div class="wrapper"></div>
    <div class="fix-wrapper">
      <breadcrumb :crumbs="[$t('menu.profile')]" />
      <div class="container">
        <el-form ref="userform" :model="user" label-width="80px" size="small">
          <div class="pd20">
            <fieldset>
              <legend>{{ $t("text.baseInfo") }}</legend>
              <el-row :gutter="20">
                <el-col :span="8">
                  <el-form-item :label="$t('user.name')">{{
                    user.name
                  }}</el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item :label="$t('user.phone')">{{
                    user.phone
                  }}</el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item :label="$t('user.admin')">{{
                    $t("boolean." + user.admin)
                  }}</el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col v-if="user.shopName != null" :span="8">
                  <el-form-item :label="$t('user.shop')">{{
                    user.shopName
                  }}</el-form-item>
                </el-col>
              </el-row>
            </fieldset>
          </div>
          <div class="form-footer">
            <el-button type="default" size="medium" plain @click="edit">{{
              $t("text.edit")
            }}</el-button>
            <el-button
              type="default"
              size="medium"
              plain
              @click="editPassword"
              >{{ $t("action.editPassword") }}</el-button
            >
          </div>
        </el-form>
      </div>
    </div>
    <!-- 编辑 -->
    <el-dialog
      :close-on-click-modal="false"
      :title="$t('action.editName')"
      :visible.sync="editDF"
      width="30%"
    >
      <el-form ref="editObjForm" :model="editObj">
        <el-form-item
          prop="name"
          :rules="[
            {
              required: true,
              message: $t('rules.required', [$t('user.name')]),
              trigger: 'blur',
            },
          ]"
        >
          <el-input
            size="small"
            v-model.trim="editObj.name"
            :placeholder="$t('user.name')"
          />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          size="small"
          plain
          :loading="editSubmitDoing"
          @click="editSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button type="default" size="small" @click="editDF = false">{{
          $t("text.close")
        }}</el-button>
      </span>
    </el-dialog>
    <!-- 编辑密码 -->
    <el-dialog
      :close-on-click-modal="false"
      :title="$t('action.editPassword')"
      :visible.sync="editPasswordDF"
      width="30%"
    >
      <el-form
        ref="editPasswordObjForm"
        :model="editPasswordObj"
        label-width="80px"
      >
        <el-form-item
          :prop="'password'"
          :label="$t('user.password')"
          :rules="[
            { required: true, validator: validatePassword, trigger: 'blur' },
          ]"
        >
          <el-input
            size="small"
            v-model.trim="editPasswordObj.password"
            :placeholder="$t('user.password')"
            type="password"
          />
        </el-form-item>
        <el-form-item
          :prop="'_checkPassword'"
          :label="$t('user.checkPassword')"
          :rules="[
            {
              required: true,
              validator: validateCheckPassword,
              trigger: 'blur',
            },
          ]"
        >
          <el-input
            size="small"
            v-model.trim="editPasswordObj._checkPassword"
            :placeholder="$t('user.checkPassword')"
            type="password"
          />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          size="small"
          plain
          :loading="editPasswordSubmitDoing"
          @click="editPasswordSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button
          type="default"
          size="small"
          @click="editPasswordDF = false"
          >{{ $t("text.close") }}</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import ls from "store2";
import Permit from "../utils/permit";
import User from "../api/user";
import { page } from "../utils/mixins";

export default {
  mixins: [page],
  data() {
    var validatePassword = (rule, value, callback) => {
      const self = this;
      if (value == null || value === "") {
        callback(
          new Error(this.$t("rules.required", [self.$t("user.password")]))
        );
        return;
      } else {
        if (self.editPasswordObj._checkPassword !== "") {
          self.$refs.editPasswordObjForm.validateField("_checkPassword");
        }
        callback();
      }
    };
    var validateCheckPassword = (rule, value, callback) => {
      const self = this;
      if (value == null || value === "") {
        callback(new Error(self.$t("prompt.passwordAgain")));
        return;
      }
      if (value !== this.editPasswordObj.password) {
        callback(new Error(self.$t("prompt.passwordDiffer")));
        return;
      }
      callback();
    };
    return {
      user: {},
      // 编辑
      editDF: false,
      editObj: {
        name: null,
      },
      editSubmitDoing: false,
      // 编辑密码
      editPasswordDF: false,
      validatePassword: validatePassword,
      validateCheckPassword: validateCheckPassword,
      editPasswordObj: {
        password: null,
        _checkPassword: null,
      },
      editPasswordSubmitDoing: false,
    };
  },

  computed: {},
  created() {
    const self = this;
    self.user = Permit.currentUser();
  },
  methods: {
    // 编辑
    edit() {
      const self = this;
      self.editObj.name = self.user.name;
      self.editSubmitDoing = false;
      self.editDF = true;
    },
    editSubmit() {
      const self = this;
      self.$refs.editObjForm.validate((valid) => {
        if (valid) {
          self.editSubmitDoing = true;
          User.updateName(this.user.id, self.editObj).then(function (res) {
            if (res.status === 200) {
              self.editSubmitDoing = false;
              self.editDF = false;
              self.$message({
                message: self.$t("prompt.editSuccess"),
                type: "success",
              });
              self.updateTenantUser();
            } else {
              self.sysError();
            }
          });
        } else {
          return false;
        }
      });
    },
    // 编辑密码
    editPassword() {
      const self = this;
      self.editPasswordObj.password = null;
      self.editPasswordSubmitDoing = false;
      self.editPasswordDF = true;
    },
    editPasswordSubmit() {
      const self = this;
      self.$refs.editPasswordObjForm.validate((valid) => {
        if (valid) {
          self.editPasswordSubmitDoing = true;
          User.updatePassword(self.user.id, self.editPasswordObj).then(
            function (res) {
              if (res.status === 200) {
                self.editPasswordSubmitDoing = false;
                self.editPasswordDF = false;
                self.$message({
                  message: self.$t("prompt.editSuccess"),
                  type: "success",
                });
                self.updateTenantUser();
              } else {
                self.sysError();
              }
            }
          );
        } else {
          return false;
        }
      });
    },
    updateTenantUser() {
      const self = this;
      User.findById(self.user.id).then(function (res) {
        if (res.data.code === 200) {
          self.user = res.data.entity;
          ls.session("USER", self.user);
          ls.session("TENANT", self.user.tenant);
        } else {
          self.sysError();
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
</style>